// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@4.3.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".one-login-logout-component[data-v-7a8d1e31]{padding:.5rem 1rem}.one-login-logout-component[data-v-7a8d1e31]:hover{opacity:.7}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
